"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Transaction = exports.BankAccount = void 0;
var BankAccount = /** @class */ (function () {
    function BankAccount(bankAccObj) {
        this.accNumber = "";
        this.bankId = "";
        this.bankName = "";
        this.bsb = "";
        this.transactionCounter = 0;
        this.latestUpdate = new Date().getTime();
        this.transactions = [];
        Object.assign(this, bankAccObj);
    }
    Object.defineProperty(BankAccount.prototype, "bankBalance", {
        get: function () {
            var _a, _b, _c;
            return (_c = (_b = (_a = this.transactions[0]) === null || _a === void 0 ? void 0 : _a.bankBalance) !== null && _b !== void 0 ? _b : this._bankBalance) !== null && _c !== void 0 ? _c : null;
        },
        set: function (val) { this._bankBalance = val; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BankAccount.prototype, "runningBalance", {
        get: function () {
            var _a, _b, _c;
            return (_c = (_b = (_a = this.transactions[0]) === null || _a === void 0 ? void 0 : _a.runningBalance) !== null && _b !== void 0 ? _b : this._runningBalance) !== null && _c !== void 0 ? _c : null;
        },
        set: function (val) { this._runningBalance = val; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BankAccount.prototype, "latestDate", {
        get: function () {
            var _a, _b, _c;
            return (_c = (_b = (_a = this.transactions[0]) === null || _a === void 0 ? void 0 : _a.date) !== null && _b !== void 0 ? _b : this._latestDate) !== null && _c !== void 0 ? _c : null;
        },
        set: function (val) { this._latestDate = val; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BankAccount.prototype, "lastIndex", {
        get: function () {
            var _a, _b, _c;
            return (_c = (_b = (_a = this.transactions[0]) === null || _a === void 0 ? void 0 : _a.index) !== null && _b !== void 0 ? _b : this._lastIndex) !== null && _c !== void 0 ? _c : null;
        },
        set: function (val) { this._lastIndex = val; },
        enumerable: false,
        configurable: true
    });
    BankAccount.prototype.toObject = function () {
        return Object.assign({}, this);
    };
    return BankAccount;
}());
exports.BankAccount = BankAccount;
var Transaction = /** @class */ (function () {
    function Transaction(transObj) {
        this.date = 0;
        this.narration = "";
        this.type = "";
        this.transaction = 0;
        this.bankBalance = 0;
        this.runningBalance = 0;
        this.index = 0;
        this.recon = "";
        this.tags = [];
        this.bpayRecon = false;
        Object.assign(this, transObj);
    }
    Transaction.prototype.toJson = function () {
        return __assign(__assign({ bankBalance: this.bankBalance, date: this.date, index: this.index, narration: this.narration, runningBalance: this.runningBalance, transaction: this.transaction, type: this.type, recon: this.recon }, (this.tags ? { tags: this.tags } : {})), (this.update ? { update: this.update } : {}));
    };
    return Transaction;
}());
exports.Transaction = Transaction;
